// @ts-nocheck
import type * as Types from '../../../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import { CurrentUserOrderFragmentDoc } from '../../../graphql/current-user-orders';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DonorPortalCancelRecurringDonationMutationVariables = Types.Exact<{
  input: Types.DonorPortalCancelRecurringDonationInput;
}>;


export type DonorPortalCancelRecurringDonationMutation = { __typename?: 'Mutation', donorPortalCancelRecurringDonation: { __typename?: 'CurrentUserOrder', id: string, created: number, amount: number, recurrenceInterval: Types.DonationRecurrenceInterval, canceled?: number | null, nextPayment?: number | null, lastPaymentDate?: number | null, paymentFailing: boolean, canRestart: boolean, paymentMethodType: Types.CurrentUserPaymentMethodType, campaignTitle?: string | null, workspaceWebId: string, utm: { __typename?: 'UtmData', medium?: string | null, source?: string | null, campaign?: string | null, content?: string | null } } };


export const DonorPortalCancelRecurringDonationDocument = /*#__PURE__*/ gql`
    mutation DonorPortalCancelRecurringDonation($input: DonorPortalCancelRecurringDonationInput!) {
  donorPortalCancelRecurringDonation(input: $input) {
    ...CurrentUserOrder
  }
}
    ${CurrentUserOrderFragmentDoc}`;

/**
 * __useDonorPortalCancelRecurringDonationMutation__
 *
 * To run a mutation, you first call `useDonorPortalCancelRecurringDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDonorPortalCancelRecurringDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [donorPortalCancelRecurringDonationMutation, { data, loading, error }] = useDonorPortalCancelRecurringDonationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDonorPortalCancelRecurringDonationMutation(baseOptions?: Apollo.MutationHookOptions<DonorPortalCancelRecurringDonationMutation, DonorPortalCancelRecurringDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DonorPortalCancelRecurringDonationMutation, DonorPortalCancelRecurringDonationMutationVariables>(DonorPortalCancelRecurringDonationDocument, options);
      }
export type DonorPortalCancelRecurringDonationMutationHookResult = ReturnType<typeof useDonorPortalCancelRecurringDonationMutation>;